import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../classes/tradePlan/tradePlanProvider';
import { BorderAndLabel } from '../../../../../atomic/atomicComponentLibrary/utility/borderAndLabel/BorderAndLabel';
import ScrollableArea from '../../../../../atomic/atomicComponentLibrary/utility/scrollableArea/ScrollableArea';
import { fontSizes } from '../../../../../atomic/text/Text';
import style from './ExitTacticSection.module.css';
import { SimpleAtrTrail } from './tactics/atrTrail/SimpleAtrTrail';
import { SimpleCandleTrail } from './tactics/candleTrail/SimpleCandleTrail';
import { SimpleGreenToRedCandles } from './tactics/greenToRedCandles/SimpleGreenToRedCandles';
import { SimpleLossLimit } from './tactics/lossLimit/SimpleLossLimit';
import { SimpleMfeRetracement } from './tactics/mfeRetracement/SimpleMfeRetracement';
import { SimplePositionPriceTrail } from './tactics/positionPriceTrail/SimplePositionPriceTrail';
import { SimpleRatchetBracket } from './tactics/ratchetBracket/SimpleRatchetBracket';
import { SimpleUnderlyingPriceTrail } from './tactics/underlyingPriceTrail/SimpleUnderlyingPriceTrail';
type Props = {
  candleDuration: number;
  timeUnit: string;
};

export const ExitTacticSection = observer(
  ({ candleDuration, timeUnit }: Props) => {
    const tradePlanForm: TradePlanData = useTradePlanFormStore();
    const instrument = tradePlanForm.instrument;
    return (
      <BorderAndLabel
        label="Exit Tactics"
        color="white"
        fontSize={fontSizes.body3}
        margin="10px 0 0 10px"
        padding='5px 0 5px 0'
      >
        <div className={style.container}>
          <ScrollableArea
            vertical={true}
            horizontal={false}
            width="100%"
            height="418px"
            border="none"
          >
            <SimpleLossLimit />
            <SimpleCandleTrail
              candleDuration={candleDuration}
              timeUnit={timeUnit}
            />
            <SimpleRatchetBracket />
            <SimpleAtrTrail
              candleDuration={candleDuration}
              timeUnit={timeUnit}
            />
            <SimpleGreenToRedCandles
              candleDuration={candleDuration}
              timeUnit={timeUnit}
            />
            <SimpleMfeRetracement />
            {instrument === 'option' ? <SimpleUnderlyingPriceTrail /> : null}
            <SimplePositionPriceTrail />
          </ScrollableArea>
        </div>
      </BorderAndLabel>
    );
  }
);
